<template>
  <v-container class="pa-0 ma-0 pb-8" style="height: 100%">
    <v-container
      v-if="Preview"
      class="pa-3 ma-0"
      style="line-height: 1.3; border: 1px solid #000"
    >
      <v-card-text
        class="pa-0 ma-0 text-center text-body-1 d-flex align-center justify-center"
        style="border: 1px solid #000; border-bottom: none; min-height: 70px"
      >
        {{ contractTitel }}
      </v-card-text>
      <div
        class="contract-preview-text"
        v-html="contractText"
        style="
          border: 1px solid #9e9e9e;
          text-align: justify;
          direction: rtl;
          padding: 6px 8px;
          font-size: 12px;
        "
      ></div>
      <v-row class="mt-1" justify="space-between">
        <v-col cols="5" class="text-center">
          <div style="padding: 20px; border-radius: 0px; min-height: 60px">
            {{ FirstSignature }}
          </div>
        </v-col>

        <v-col cols="5" class="text-center">
          <div style="padding: 20px; border-radius: 0px; min-height: 60px">
            {{ SecondSignature }}
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-form
      v-if="!Preview"
      class="pa-0 ma-0"
      ref="form"
      v-model="formValid"
      @submit.prevent
    >
      <v-row
        dense
        class="pa-0 ma-0"
        :style="{ rowGap: isMobile || isTablet ? '25px' : undefined }"
      >
        <!-- right Form -->
        <v-col cols="12" md="8" class="pe-0">
          <div class="upload-box pe-3 ps-3 mt-1">
            <v-card-text class="pa-0 ma-0 py-2 text-body-1 text-center">{{
              $t("Edit the contract title")
            }}</v-card-text>
            <v-textarea
              v-model="contractTitel"
              outlined
              auto-grow
              rows="2"
              class="pa-0 pt-1 ma-0"
              label=""
            ></v-textarea>
            <v-card-text class="pa-0 ma-0 pb-2 pt-1 text-body-1 text-center">{{
              $t("Edit the contract text")
            }}</v-card-text>
            <div ref="editorDom">
              <tiptap-vuetify
                ref="editor"
                v-model="contractText"
                :extensions="extensions"
                :toolbar-attributes="{ color: '#ababab', dark: true }"
                :card-props="{ elevation: 0, outlined: true, flat: true }"
                class="contract-editor ma-0"
              />
            </div>
          </div>
          <v-container
            class="signature-box pt-2 pa-0 ps-3 pe-3 ma-0 d-flex justify-space-between gap-2"
          >
            <v-container class="pa-0 ma-0 d-flex">
              <v-card-text class="pa-0 ma-0 pt-1 text-body-2">
                {{ $t("First signature text") }}:
              </v-card-text>
              <v-text-field
                v-model="FirstSignature"
                :rules="[(v) => !!v || $t('is-required')]"
                outlined
                clearable
                dense
                class="ps-1"
              />
            </v-container>
            <v-container class="pa-0 ma-0 d-flex">
              <v-card-text class="pt-1 pa-0 ma-0 text-body-2">
                {{ $t("Second signature text") }}:
              </v-card-text>
              <v-text-field
                v-model="SecondSignature"
                :rules="[(v) => !!v || $t('is-required')]"
                outlined
                clearable
                dense
                class="ps-1"
              />
            </v-container>
          </v-container>
        </v-col>
        <!-- Left Form  -->
        <v-col cols="12" md="4" class="pe-0 ps-2">
          <v-container class="pa-0 ma-0 my-1 d-flex flex-column gap-7">
            <v-row dense class="ma-0 pa-0" style="row-gap: 27px">
              <v-col
                cols="12"
                md="12"
                :class="['pt-0', !(isMobile || isTablet) ? 'pe-0' : '']"
              >
                <v-text-field
                  v-model="contractName"
                  :label="$t('contract_name')"
                  :rules="[(v) => !!v || $t('is-required')]"
                  outlined
                  clearable
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="12"
                :class="['', !(isMobile || isTablet) ? 'pe-0' : '']"
              >
                <v-container
                  class="pa-3 ma-0"
                  style="
                    max-height: 350px;
                    overflow-y: auto;
                    border: solid 1px #b9b8b8;
                    border-radius: 4px;
                  "
                >
                  <h3 class="mb-4 pr-3">{{ $t("variables") }}</h3>
                  <v-list dense class="pa-0">
                    <div
                      v-for="(item, index) in contractVariables"
                      :key="index"
                      @click="insertVariable(item.key)"
                      style="cursor: pointer"
                    >
                      <v-list-item class="py-2">
                        <v-list-item-content>
                          <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider />
                    </div>
                  </v-list>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-form>
    <!--  snackbar --->
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :loading="loading"
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from "moment-jalaali";
moment.loadPersian({ dialect: "persian-modern" });
import General from "@/Mixins/general";
import FlexibleAutocomplete from "../../../../components/general/patial/FlexibleAutocomplete.vue";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
  Image,
  Table,
  TableCell,
  TableHeader,
  TableRow,
} from "tiptap-vuetify";
export default {
  name: "contract-form",
  components: {
    FlexibleAutocomplete,
    TiptapVuetify,
  },
  mixins: [General],
  props: {
    saveNew: {
      type: Boolean,
      default: false,
    },
    saveReturn: {
      type: Boolean,
      default: false,
    },
    showPreview: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      Preview: false,
      contractVariables: [],
      contractName: null,
      saleryFactorsTemplate: null,
      extensions: [
        History,
        Table,
        TableCell,
        TableHeader,
        TableRow,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        Image,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      FirstSignature: "محل امضای كارفرما",
      SecondSignature: "محل امضای كارگر",
      contractTitel: "جمهوری اسلامی ایران وزارت تعاون، کار و رفاه اجتماعی",
      contractText: `
   این قرارداد به موجب ماده (10) قانون كار جمهوری اسلامی ایران بین كارفرما / نماینده قانونی كارفرما و كارگر منعقد می شود.<br><br>

1)مشخصات طرفین:<br><br>

كارفرما/ نماینده قانونی كارفرما $[workshop_name]$ به مدیریت: $[boss]$  و به نشانی: $[workshop_address]$ و

كارگر $[first_name]$ $[last_name]$<br><br> فرزند $[father_name]$ متولد $[birth_place]$ شماره شناسنامه $[NIC]$  شماره ملی $[melli_code]$ میزان تحصیلات $[degree]$ به نشانی: $[person_address]$ منعقد می گردد.<br><br>

2) نوع قرارداد: $[contract_type]$ <br><br>

3) نوع كار یا حرفه یا حجم كار یا وظیفه ای كه كارگر به آن اشتغال می یابد: $[semat]$ <br><br>

4) محل انجام كار: $[workshop_address]$ <br><br>

5) مدت قرارداد: از تاریخ $[agreement_start_date]$  تا تاریخ $[agreement_end_date]$<br><br>

6) میزان ساعت كار و ساعت شروع و پایان آن با توافق طرفین تعیین می‌گردد، ساعت كار نمی تواند بیش از میزان مندرج در قانون كار تعیین شود لیكن كمتر از آن مجاز است.<br><br>

7) حق السعی:<br><br>

حقوق روزانه: $[daily_salary]$  ریال <br><br>

حقوق ماهانه: $[month_salary]$  ریال <br><br>

حق غذا: $[food]$ ریال <br><br>

حق بن: $[bone]$ ریال <br><br>

حق مسکن: $[home]$ ریال <br><br>

حق جذب: $[attract]$ ریال <br><br>

سایر مزایا: $[benefit]$ ریال <br><br>

مجموع دریافتی: $[sum]$  ریال <br><br>



8) حقوق و مزایا: حقوق و مزایا بصورت هفتگی / ماهانه كارگر به حساب شماره $[account_number]$ نزد بانك $[bank]$ توسط كارفرما یا نماینده قانونی وی پرداخت می گردد.<br><br>

9) بیمه: به موجب ماده 148 قانون كار كارفرمایان كارگاه های مشمول این قانون مكلفند بر اساس قانون تامین اجتماعی نسبت به بیمه نمودن كارگران واحد خود اقدام نمایند.<br><br>

10) عیدی و پاداش سالانه: به موجب ماده واحده قانون مربوط به تعیین عیدی و پاداش سالانه كارگران شاغل در كارگاه‌های مشمول قانون كار مصوب ۱۳۷۰/۱۲/۰۶ مجلس شورای اسلامی به ازای یك سال كار معادل شصت روز مزد ثابت/مبنا (تاسقف نود روز حداقل مزد روزانه قانونی كارگران) به عنوان عیدی و پاداش سالانه به كارگر پرداخت می شود. برای كار كمتر از یك سال میزان عیدی و پاداش و سقف مربوط به نسبت محاسبه خواهد شد.<br><br>

11) حق سنوات یا مزایای پایان كار: به استناد ماده 24 قانون كار در صورت خاتمه قراردادكار، كار معین  یا مدت موقت، كارفرما مكلف است به كارگری كه مطابق قرارداد یكسال یا بیشتر، به كار اشتغال داشته است برای هر سال سابقه، اعم از متوالی یا متناوب  بر اساس آخرین حقوق مبلغی معادل یك ماه حقوق به عنوان مزایای پایان كار(حق سنوات) به وی پرداخت نماید.<br><br>

12) فسخ قرارداد: به استناد ماده 25 قانون كار و تبصره آن در قرارداد كار موقت و یا برای انجام كار معین هیچ یك از طرفین به تنهایی حق فسخ آن را ندارند و رسیدگی به اختلافات ناشی از این نوع قرارداد در صلاحیت هیات‌های تشخیص و حل اختلاف می باشد.<br><br>

13) سایر: سایر موضوعات مندرج در قانون كار و مقررات تبعی از جمله مرخصی استحقاقی نسبت به این قرارداد اعمال خواهد شد.<br><br>

14) این قرارداد در 4 نسخه تنظیم می شود كه یك نسخه نزد كارفرما یك نسخه نزد كارگر یك نسخه به تشكل كارگری (در صورت وجود) و یك نسخه نیز توسط كارفرما به اداره تعاون كار و رفاه اجتماعی محل تحویل می شود.<br><br>
`,
      loading: false,
      return: false,
      isVisible: false,
      formValid: null,
      currencyId: "",
      optionsNew: {
        page: 1,
        itemsPerPage: 10,
      },
    };
  },
  watch: {
    saleryFactorsTemplate: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.advantagesData = [];
          this.deductionsData = [];
          this.CommitmentByConfigId = newValue.id;
          this.getSalaryCommitmentByConfigId(newValue.id);
        } else {
          this.advantagesData = [];
          this.deductionsData = [];
        }
      },
    },
    saveNew: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.save(this.return);
        }
      },
    },
    saveReturn: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.return = true;
          this.save(this.return);
        }
      },
    },
    showPreview: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.Preview = true;
          this.$emit("is-loading", false);
        } else {
          this.Preview = false;
        }
      },
    },
  },
  computed: {
    currencyName() {
      return this.$store.state.currencyName;
    },
    rules() {
      return {
        required: (v) => !!v || this.$t("is-required"),
      };
    },
  },
  mounted() {
    this.getVariable();
    if (this.$route.params.id) {
      this.getContractById();
    }
  },
  methods: {
    insertVariable(key) {
      const variable = `${key}`;
      const editor = this.$refs.editor?.editor;
      if (!editor) return;
      const { from, to } = editor.state.selection;
      const tr = editor.state.tr.insertText(variable, from, to);
      editor.view.dispatch(tr);
      editor.view.focus();
    },
    fetchWorkshopApi(payload) {
      var app = this;
      let params = {
        page: payload.page,
        search: payload.search || "",
        options: JSON.stringify({
          itemsPerPage: 10,
        }),
        currency: app.currencyId,
      };
      return app.$axios
        .get(app.$endpoint + "workshop", { params })
        .then(function (response) {
          let list = response && response.data.data ? response.data.data : [];
          return {
            items: list,
            hasMore: list.length === 10,
          };
        });
    },
    save(val) {
      this.CreateContract(val);
    },
    CreateContract(val) {
      var app = this;
      let id = this.$route.params.id || null;
      if (id != null) {
        app.$axios
          .put(this.$endpoint + "contract/" + id, {
            contratc_header: app.contractTitel || "",
            footer: {
              FirstSignature: app.FirstSignature || "",
              SecondSignature: app.SecondSignature || "",
            },
            body: app.contractText || "",
            name: app.contractName || "",
          })
          .then((response) => {
            if (val == true) {
              app.$router.push("/payroll/contract_list");
              app.$emit("again-ready-to-save");
              app.$emit("is-loading", false);
            }
          })
          .catch((err) => {
            app.loading = false;
            app.$emit("again-ready-to-save");
            app.serverErrorHandeler(err);
          })
          .finally(() => {
            app.$emit("again-ready-to-save");
            app.$emit("is-loading", false);
            app.loading = false;
          });
      } else {
        app.$axios
          .post(this.$endpoint + "contract", {
            contract_header: app.contractTitel || "",
            footer: {
              FirstSignature: app.FirstSignature || "",
              SecondSignature: app.SecondSignature || "",
            },
            body: app.contractText || "",
            name: app.contractName || "",
          })
          .then((response) => {
            if (val == true) {
              app.$router.push("/payroll/contract_list");
              app.$emit("again-ready-to-save");
              app.$emit("is-loading", false);
            }
          })
          .catch((err) => {
            app.loading = false;
            app.$emit("again-ready-to-save");
            app.$emit("is-loading", false);
            app.serverErrorHandeler(err);
          })
          .finally(() => {
            app.$emit("again-ready-to-save");
            app.$emit("is-loading", false);
            app.loading = false;
          });
      }
    },
    getContractById() {
      var app = this;
      app.loading = true;
      let contractId = this.$route.params.id;
      app.$axios
        .get(app.$endpoint + "contract/" + contractId)
        .then((response) => {
          this.contractTitel = response.data.contract_header;
          this.FirstSignature = response.data.footer.FirstSignature;
          this.SecondSignature = response.data.footer.SecondSignature;
          this.contractText = response.data.body;
          this.contractName = response.data.name;
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.initialLoading = false;
          app.paginationLoading = false;
        });
    },
    getVariable() {
      var app = this;
      app.$axios
        .get(app.$endpoint + "hrm/get-contract-items")
        .then((response) => {
          app.contractVariables = [];
          response.data.forEach((item) => {
            app.contractVariables.push({
              key: item.code,
              title: item.name,
            });
          });
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.$emit("initial-Loading-is", false);
          app.$emit("call-refresh");
          app.paginationLoading = false;
        });
    },
  },
};
</script>

<style scoped>
::v-deep(.v-input .v-label.v-label--active) {
  top: 8px !important;
}
.upload-box {
  border: 1px solid #ababab;
  /* border-bottom: none; */
  border-radius: 4px 4px 0 0;
  width: 100%;
  height: fit-content;
}
.signature-box {
  border: 1px solid #ababab;
  border-top: none;
  border-radius: 0 0 4px 4px;
  width: 100%;
  height: 50px;
}
.upload-box ::v-deep .tiptap-vuetify-editor .v-card {
  margin-top: 0 !important;
}
::v-deep .tiptap-vuetify-editor__content p {
  line-height: 1.4;
  font-size: 13px;
  text-align: justify;
  direction: rtl;
  word-break: break-word;
  white-space: pre-wrap;
  padding: 12px;
}
::v-deep.tiptap-vuetify-editor__content br {
  display: block;
  margin-bottom: 10px;
  content: "";
}
.button-upload {
  color: #616161;
  max-height: 172px;
}
.uploadIMG {
  color: #616161;
  max-height: 172px;
}
::v-deep .upload-box .v-input__control {
  /* border: 2px dashed #ccc; */
  border-radius: 4px;
  height: 100%;
}

::v-deep .upload-box .v-input__slot {
  justify-content: center;
  align-items: center;
  height: 100%;
}

::v-deep .upload-box input {
  display: none;
}
.upload-box ::v-deep .v-text-field__details {
  display: none;
}
::-webkit-scrollbar {
  display: none;
}
</style>
